import type { Square } from 'chess.js'

export const IMMORTAL_GAME = {
    title: 'The Immortal Game',
    place: 'London, 1851',
    opening: "King's Gambit Accepted",
    white: 'Adolf Anderssen',
    black: 'Lionel Kieseritzky',
    moves: [
        'e4', 'e5',
        'f4', 'exf4',
        'Bc4', 'Qh4+',
        'Kf1', 'b5',
        'Bxb5', 'Nf6',
        'Nf3', 'Qh6',
        'd3', 'Nh5',
        'Nh4', 'Qg5',
        'Nf5', 'c6',
        'g4', 'Nf6',
        'Rg1', 'cxb5',
        'h4', 'Qg6',
        'h5', 'Qg5',
        'Qf3', 'Ng8',
        'Bxf4', 'Qf6',
        'Nc3', 'Bc5',
        'Nd5', 'Qxb2',
        'Bd6', 'Bxg1',
        'e5', 'Qxa1+',
        'Ke2', 'Na6',
        'Nxg7+', 'Kd8',
        'Qf6+', 'Nxf6',
        'Be7#'
    ],
    notes: {
        3: "The King's Gambit: a pawn offered on move two.",
        4: "Black takes the gambit pawn.",
        6: "An early queen check.",
        7: "The king steps aside and gives up castling.",
        21: "Anderssen leaves his bishop to be taken.",
        35: "Both white rooks are now on offer.",
        36: "Black grabs the first rook.",
        38: "And the second one, with check.",
        41: "The knight drives the king out.",
        43: "The queen sacrifice.",
        45: "Checkmate with three minor pieces."
    } as Record<number, string>
}

export const OPERA_PUZZLE = {
    title: "Morphy's finish",
    place: 'Paris Opera, 1858',
    white: 'Paul Morphy',
    black: 'Duke Karl of Brunswick and Count Isouard',
    blackShort: 'The Duke and the Count',
    fen: '4kb1r/p2n1ppp/4q3/4p1B1/4P3/1Q6/PPP2PPP/2KR4 w k - 0 16',
    firstMoveNumber: 16,
    solution: ['Qb8+', 'Nxb8', 'Rd8#'],
    hints: [
        {
            square: 'b3' as Square,
            text: "Your queen can force the knight on d7 to move. What would that open up?"
        },
        {
            square: 'd1' as Square,
            text: "The d-file is wide open now. Which piece has been waiting for it?"
        }
    ]
}
